import React, { useState, useEffect } from "react";

import SimulatorLayout from "../components/layout";
import { connect } from "react-redux";
import {
  setUser,
  setAlterarProposta,
  setCliente,
  setProposta,
} from "../store/actions/dados";
import { sendData } from "../helpers/auth";
import { uriList } from "../helpers/config";

import Data from "../views/simulator/data";
import Address from "../views/simulator/address";
import Contact from "../views/simulator/contact";
import Complement from "../views/simulator/complement";
import ComplementOriginal from "../views/simulator/complement_original";
import Bank from "../views/simulator/bank";
import Documents from "../views/simulator/documents";
import Status from "./status";
import Result from "../views/simulator/result";

import CreditoPes from "../components/form/admin/CreditoPessoal";

function CreditoPessoal({ ...props }) {
  const [enviando, setEnviando] = useState(false);
  const [data, setData] = useState({});
  const [step, setStep] = useState({
    cur: 0,
    maxStep: 8,
  });

  useEffect(() => {
    if (!props.alterar) _iniciar();
    else {
      console.log("Portabilidade - detalhes: ", props.detalhes.posicao);
      if (["simulacao"].indexOf(props.detalhes.posicao.toLowerCase()) >= 0)
        setStep({ ...step, cur: 1 });
      else setStep({ ...step, cur: step.maxStep });
    }
  }, []);

  function _iniciar() {
    props.setProposta("limpar");
    props.setAlterarProposta(false, props.detalhes);
    props.alterarCliente(null);
  }

  const reRender = () => {
    setStep({ ...step, cur: -1 });
    setStep({ ...step, cur: 0 });
  };

  const toggleStep = async (n, dados, result) => {
    console.log("Portabilidade - toggleStep: ", n);
    if (dados) setData(dados);
    if (!n || n === undefined) n = 1;
    let _next = step.cur + n;
    if (_next >= 0 && _next <= step.maxStep) setStep({ ...step, cur: _next });

    //-- Enviando proposta para o cliente
    if (step.cur >= step.maxStep) {
      // if (props.user?.tipo == "AGENTE") return setStep({ ...step, cur: 0 });
      console.log(
        "CreditoPessoal.toggleStep - enviando proposta para o cliente"
      );
      setEnviando(true);

      await sendData({
        uri: uriList("enviarParaAssinatura"),
        content: { proposta_uuid: props.proposta || dados.uuid, sms: true },
        method: "POST",
      })
        .then((res) => {
          setEnviando(false);
          if (res.status && parseInt(res.status) > 200) throw new Error();
        })
        .catch((e) => {
          setEnviando(false);
        });

      if (props.buscarPropostas) {
        props.buscarPropostas();
      }

      return setStep({ ...step, cur: 0 });
    }
  };

  const RenderScreen = ({ ...props }) =>
  ({
    0: <CreditoPes toggleStep={toggleStep} data={data} reRender={reRender} />,

    1: <Result title="Simulação" toggleStep={toggleStep} admin={true} />,

    2: (
      <Data
        title="Dados Pessoais"
        toggleStep={toggleStep}
        admin={true}
        portabilidade={false}
      />
    ),

    3: (
      <Address
        title="Endereço"
        toggleStep={toggleStep}
        admin={true}
        portabilidade={false}
      />
    ),

    4: (
      <Contact
        title="Contato"
        toggleStep={toggleStep}
        admin={true}
        portabilidade={false}
      />
    ),

    5: (
      <Bank
        title="Dados Bancários"
        toggleStep={toggleStep}
        admin={true}
        portabilidade={false}
      />
    ),

    6: (
      <Complement
        title="Complemento"
        toggleStep={toggleStep}
        admin={true}
        portabilidade={false}
      />
    ),

    7: (
      <ComplementOriginal
        title="Complemento Original"
        toggleStep={toggleStep}
        admin={true}
        portabilidade={false}
      />
    ),

    8: (
      <Documents
        title="Documentos"
        toggleStep={toggleStep}
        admin={true}
        portabilidade={false}
      />
    ),

    9: (
      <Status
        preencherCli={false}
        data={props.detalhes}
        portabilidade={false}
        toggleStep={toggleStep}
        enviando={enviando}
      />
    ),
  }[props.step] || (
      <>
        <h1>404!</h1>
        <h4>Esse formulário: {props.step}não existe! </h4>
      </>
    ));

  return (
    <>
      {step.cur >= step.maxStep ? (
        <RenderScreen step={step.cur} />
      ) : (
        <SimulatorLayout admin={true}>
          <RenderScreen step={step.cur} />
        </SimulatorLayout>
      )}
    </>
  );
}

function mapStateToProps(state) {
  return {
    user: state.dados.user,
    proposta: state.dados.proposta,
    detalhes: state.dados.detalhes,
  };
}

function mapActionToProps(dispatch) {
  return {
    setProposta(novaProposta) {
      dispatch(setProposta(novaProposta));
    },
    alterarUser(novoUser) {
      dispatch(setUser(novoUser));
    },
    setAlterarProposta(alterar) {
      dispatch(setAlterarProposta(alterar));
    },
    alterarCliente(novoCliente) {
      dispatch(setCliente(novoCliente));
    },
  };
}

export default connect(mapStateToProps, mapActionToProps)(CreditoPessoal);
